module.exports = __webpack_public_path__ + "img/2016华药会.901aa2c2.jpg";